module.exports = __webpack_public_path__ + "static/media/curriculum_s1.cc65d048.png";